// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {
  TGetDesktopOnboardingsModel,
  IMappers,
  TGetDesktopOnboardingsResponse,
  TGetDesktopOnboardingsResponse_1,
  TGetDesktopOnboardingsResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TGetDesktopOnboardingsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'mobile-app-onboarding',
  pathApi: '/v1/get-desktop-onboardings/',
} as TGetDesktopOnboardingsModel;

export function createGetDesktopOnboardingsModel(): TGetDesktopOnboardingsModel {
  return {
    ...defaultConfig,
  };
}

export interface IGetDesktopOnboardingsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchGetDesktopOnboardings<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IGetDesktopOnboardingsOptions<TResponse200, TResponse400>): Promise<
  TGetDesktopOnboardingsResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetDesktopOnboardingsModel(), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TGetDesktopOnboardingsResponse_1);
    }
    if (statusCode === 400) {
      return mappers[400](response as TGetDesktopOnboardingsResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetDesktopOnboardingsResponse;
}
